export default function DiarioDataToObject(response) {
  const data = {};

  response.data.forEach((element) => {
    data.C300 = element.C300;
    data.C300p = element.C300p;
    data.IC300 = element.IC300;
    data.KpiC300Pond = element.KpiC300Pond;
    data.FTE = element.FTE;
    data.FTEp = element.FTEp;
    data.IFTE = element.IFTE;
    data.KpiFTEPond = element.KpiFTEPond;
    data.PLC = element.PLC;
    data.PLCp = element.PLCp;
    data.KpiPLCPond = element.KpiPLCPond;
    data.SCADA = element.SCADA;
    data.SCADAp = element.SCADAp;
    data.ISCADA = element.ISCADA;
    data.KpiSCADAPond = element.KpiSCADAPond;
    data.SERVIDORES = element.SERVIDORES;
    data.SERVIDORESp = element.SERVIDORESp;
    data.ISERVIDOR = element.ISERVIDOR;
    data.KpiSERVIDORPond = element.KpiSERVIDORPond;
    data.Total = element.Total;
    data.Fecha = element.Fecha;
  });
  
  return data;
}
